export default __webpack_public_path__ + "static/media/Amos Bahiya.5aa3cc41.JPG";